import {isIE} from "./helpers";
import Config, {IS_LIXIL_SERVERS} from "../config";
import graniteTransformationUkSubDomains from "./graniteTransformationUkSubDomains";

export const LOWES_DISCLAIMER_EN = "This cost includes your selection of material, edge profile, faucet cut-outs, templating, installation plus any other options you have selected. All quotes are subject to changes. No quote shall be final until the time of template. Quotes only reflect the selections, information and the amount of materials you have entered in the estimator tool. After your purchase a certified Contractor will go on site to verify all dimensions and details of your order. Price adjustments will be possible thereafter. All expenses not covered in this quote, like possible extra trip charges, 2nd story fees, oversize piece/difficult access charges,high rise installation charge which are out of program installation costs, permit fees or any other expense not captured in this quote will be added at time of template. Projects under 27 SF incur a surcharge. All quotes are valid for 30 days. ALL 3D DESIGN IMAGES ARE FOR INSPIRATIONAL PURPOSES ONLY. See a kitchen associate or Call 1-844-454-1454 to finalize your purchase."

export const getFabricatorLogo = (fabricatorData) => {
  const hardCodedLogo = `https://qc-cdn.s3.amazonaws.com/Logos/Quote-Kitchen-and-Bath.jpg`;
  const hardCodedLowesLogo = `https://qc-cdn.s3.amazonaws.com/Logos/lowes.png`;
  const hardCodedRenoDepotLogo = `https://qc-cdn.s3.amazonaws.com/Logos/reno-depot.png`;
  const hardCodedRonaLogo = `https://qc-cdn.s3.amazonaws.com/Logos/rona.png`;

  if (isIE()) {
    if (fabricatorData.isRenoDepot) {
      return hardCodedRenoDepotLogo
    } else if (fabricatorData.isRona) {
      return hardCodedRonaLogo
    } else if (fabricatorData.isLowes) {
      return hardCodedLowesLogo
    }
    return hardCodedLogo
  }

  if (Config.isDevMode() && fabricatorData.logoUrl && !fabricatorData.logoUrl.includes("http") && document.kvConfig.domain) {
    return document.kvConfig.domain + fabricatorData.logoUrl
  }

  return fabricatorData.logoUrl || hardCodedLogo
}

export const hardCodeIsLowes = () => {
  const subDomains = ["mdp_surfaces", "lowes_", "/rona.", "rona_", "rnodpt", "reno_depot"];
  if (Config.isDevMode() && (document.kvConfig.userId === 139043)) {
    return true;
  }
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
};

export const hardCodeIsAmericanImport = () => {
  const subDomains = ['americanimport', 'americanstandard2020'];
  if (Config.isDevMode() && (document.kvConfig.userId === 140460 || document.kvConfig.userId === 155479)) { //American Import //American Standard 2020
    return true;
  }
  return subDomains.some(subDomain => window.location.href.includes(subDomain));
};

export const hardCodeIsAmericanStandard = () => {
  const subDomains = ['americanstandard', "american_", "ashs"];
  if (Config.isDevMode() && (document.kvConfig.userId === 139882 || document.kvConfig.userId === 251108)) { //American Standard 2020 // Cory
    return true;
  }
  return subDomains.some(subDomain => window.location.href.toLowerCase().includes(subDomain));
};

export const hardCodeIsRona = () => {
  const subDomains = ["/rona.", "rona_"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
};

export const hardCodeIsRenoDepot = () => {
  const subDomains = ["rnodpt", "reno_depot"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
};

export const hardCodeIsHomeDepot = () => {
  const subDomains = ["home_depot"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
};

export const hardCodeIsCaesarStone = () => {
  const domains = ["quotetops.com", "quotekitchencountertops.com"];
  return document.kvConfig.isCaesarStone || domains.some(domain => window.location.href.includes(domain))
};

export const hardCodeIsModerno = () => {
  const subDomains = ["moderno"];
  return subDomains.some(subDomain => window.location.href.toLowerCase().includes(subDomain))
};

export const hardCodeIsPorcelanosa = () => {
  const subDomains = ["porcelanosa"];
  return subDomains.some(subDomain => window.location.href.toLowerCase().includes(subDomain))
};

export const hardCodeIsMcDermott = () => {
  const subDomains = ["mcdermott_", "mts_"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
};

export const hardCodeIsFlexFinish = () => {
  const subDomains = ["flexfinish", "flexfinish2", "flex_finish"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
};

export const hardCodeIsGraniteTransformation = () => {
  const subDomains = ["granite_transformations", "trend_transformations"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
};

export const hardCodeIsGraniteTransformationUK = () => {
  return graniteTransformationUkSubDomains.some(subDomain => window.location.href.includes(subDomain))
};

export const hardCodeIsLixil = () => {
  return [139247, 139616, 139882].some(userId =>  document.kvConfig.userId === userId) || ["grohe", "grohe2", "americanstandard"].some(subDomain => {
    return window.location.host && window.location.host.split && (window.location.host.split('.')[0] === subDomain)
  })
}

export const hardCodeIsAgent = () => {
  return document.kvConfig.userId === 140203 || (
    window.location.host && window.location.host.split && (window.location.host.split('.')[0] === "agent")
  )
}

export const hardCodeIsTorrco = () => {
  return document.kvConfig.userId === 140298 || document.kvConfig.userId === 140299 || (
    window.location.host && window.location.host.includes && window.location.host.includes("torrco")
  )
}

export const hardCodeIsCoburn = () => {
  return document.kvConfig.userId === 140590 || document.kvConfig.userId === 140558 || (
    window.location.host && window.location.host.includes && window.location.host.includes("coburns_")
  )
}

export const hardCodeIsSolidSurface = () => {
  return document.kvConfig.userId === 245802 || (
    window.location.host && window.location.host.includes && window.location.host.includes("solidsurface")
  )
}

export const hardCodeIsLakesideSurfaces = () => {
  return document.kvConfig.userId === 252014 || (
    window.location.host && window.location.host.includes && window.location.host.includes("lakeside_surfaces")
  )
}

export const hardCodeIsDeStefano = () => {
  return document.kvConfig.userId === 270900 || (
    window.location.host && window.location.host.includes && window.location.host.includes("de_stefano")
  ) || window.location.href.includes("fab_subdomain=de_stefano")
}

export const hardCodeIsNhance = () => {
  return document.kvConfig.userId === 268895 || (
    window.location.host && window.location.host.includes && window.location.host.includes("nhance")
  ) || window.location.href.includes("fab_subdomain=nhance")
}

export const hardCodeIsEncore = () => {
  return document.kvConfig.userId === 267710 || (
    window.location.host && window.location.host.includes && window.location.host.includes("encore")
  ) || window.location.href.includes("fab_subdomain=encore")
}

export const isEncore = hardCodeIsEncore();

export const hardCodeIsDeluxegarage = () => {
  const subDomains = ["deluxegarage"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
}

export const hardCodeIsRenuit = () => {
  const subDomains = ["renuit", "home_depot"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
}

export const hardCodeIsKitchenMagic = () => {
  const subDomains = ["kitchenmagic"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
}

export const isCabinetsFabricator = () => {
  return [256713, 246203, 256713].some(userId => document.kvConfig.userId === userId)
}

export const isProd = () => {
  const subDomains = ["quotekitchenandbath", "quotekitchencountertops"];
  return subDomains.some(subDomain => window.location.href.includes(subDomain))
}

export const isCafeCountetops = document.kvConfig.userId === 264613 || (
  window.location.host && window.location.host.includes && window.location.host.includes("cafecounterops")
);

export const hardCodeIsFabricator = (subDomain = "", fabId = null) => {
  if (!subDomain && !fabId) {
    return false
  }
  return (fabId && (document.kvConfig.userId === fabId)) || (
    window.location.host && window.location.host.includes && window.location.host.includes(subDomain)
  ) || window.location.href.includes("fab_subdomain=" + subDomain)
}

export const hardCodeIsFloform = () => {
  return hardCodeIsFabricator("floform", 264045)
}

export const hardCodeIsDealerTool = () => {
  return hardCodeIsFabricator("dealer_tool_demo", 287301)
}

export const hardCodeIsLakewood2025 = () => {
  return hardCodeIsFabricator("lakewood_countertop_2025", 288046)
}

export const hardCodeIsRebath = () => {
  return hardCodeIsFabricator("rebath")
}

export const hardCodeIsStoneSystems = () => {
  return hardCodeIsFabricator("stone_systems")
}

export const hardCodeIsNFM = () => {
  return hardCodeIsFabricator("nfm_")
}

export const fabricatorsHardcodeObject = {
  // isRebath: document.kvConfig.userId === 71520 // removed as we don't use rebath at all
  //   || window.location.href.includes("rebath")
  //   || window.location.href.includes("re-bath"),
  // isRebath: window.location.href.includes("rebath")
  //   || window.location.href.includes("re-bath")
  //   || (action.payload.companyName && (action.payload.companyName.toLowerCase().includes("rebath")
  //     || action.payload.companyName.toLowerCase().includes("re-bath")))
  //   || (action.payload.name && (action.payload.name.toLowerCase().includes("rebath")
  //     || action.payload.name.toLowerCase().includes("re-bath"))),
  isLowes: hardCodeIsLowes(),
  isRona: hardCodeIsRona(),
  isRenoDepot: hardCodeIsRenoDepot(),
  isAmericanImport: hardCodeIsAmericanImport(),
  isAmericanStandard: hardCodeIsAmericanStandard(),
  isCaesarStone: hardCodeIsCaesarStone(),
  isGraniteTransformation: hardCodeIsGraniteTransformation(),
  isGraniteTransformationUK: hardCodeIsGraniteTransformationUK(),
  isModerno: hardCodeIsModerno(),
  isMcDermott: hardCodeIsMcDermott(),
  isFlexFinish: hardCodeIsFlexFinish(),
  isLixil: hardCodeIsLixil(),
  isTorrco: hardCodeIsTorrco(),
  isCoburn: hardCodeIsCoburn(),
  isSolidSurface: hardCodeIsSolidSurface(),
  isLakesideSurfaces: hardCodeIsLakesideSurfaces(),
  isDeStefano: hardCodeIsDeStefano(),
  isNhance: hardCodeIsNhance(),
  isEncore: hardCodeIsEncore(),
  isRenuit: hardCodeIsRenuit(),
  isGrohe: IS_LIXIL_SERVERS && hardCodeIsFabricator("grohe", 139247),
  isAccentCountertops: hardCodeIsFabricator("accentcountertops", 263208),
  isLakewood2025: hardCodeIsLakewood2025(),
  isMKD: hardCodeIsFabricator("mkd", 294451),
  isDalTile: hardCodeIsFabricator("daltile", 294268),
}
